import Vue from 'vue'
import VueRouter from 'vue-router'
// import LAYOUT from '@/layouts/layout.vue'
// import Main from '@/components/Main'

const LAYOUT = () => import('@/layouts/layout.vue')
const Main = () => import('@/components/Main')
const SignIn = () => import('@/login.vue')

// import typeList from '@/components/freezone2022/typeList'
// import requestList from '@/components/freezone2022/requestList'
// import requestList from '@/components/RCEP/requestList'

// import receiveList from '@/components/freezone2022/receiveList'
// import checkfacdetailList from '@/components/freezone2022/checkfacdetailList'
// import AuditpersonList from '@/components/freezone2022/AuditpersonList'
// import carmakerList from '@/components/RCEP/carmakerList'
// import supplierList from '@/components/RCEP/supplierList'
// import partList from '@/components/RCEP/partList'
// import signerList from '@/components/RCEP/signerList'
// import sampletrackList from '@/components/tsc/sampletrackList'
// import certifyList from '@/components/RCEP/certifyList'
//<import>
Vue.use(VueRouter)

const routes = [
  {
    path: '/http*',
    beforeEnter: (to) => {
      console.log(to.fullPath.substring(1))
      window.location.replace(to.fullPath.substring(1), '_blank')
    }
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/Opt',
    name: 'Opt',
    component: () => import('@/otp.vue')
  },

  {
    path: '/',
    // name: 'layout',
    component: () => import('@/components/taimember/memberallEdit-insert')
  },
  // {
  //   path: 'about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  // {
  //   path: '/taimember/memberList',
  //   name: 'taimember_memberList',
  //   component: () => import('@/components/taimember/memberallList')
  // },
  {
    path: '/taimember/member',
    name: 'memberjuristic',
    component: () => import('@/components/taimember/memberallEdit-insert')
  },
  // {
  //   path: '/taimember/member1',
  //   name: 'memberjuristic',
  //   component: () => import('@/components/taimember/memberallEdit-insert1')
  // },
  {
    path: '/taimember/attach',
    name: 'taimember_attach',
    component: () => import('@/components/taimember/attachEdit')
  },
  {
    path: '/taimember/term',
    name: 'taimember_term',
    component: () => import('@/components/taimember/termEdit')
  }
  // {
  //   path: '/taimember/memberallEdit',
  //   name: 'taimember_term',
  //   component: () => import('@/components/taimember/memberallEdit')
  // }

  //<router>
]

const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.VUE_APP_ROOT_PATH
})

export default router
